<template>
	<div id="livemain">

	</div>
</template>

<script>
import $ from 'jquery';
import { mapActions } from 'vuex';
import { getAxiosErrorMessage } from '@/lib/helper';
import rundownItemsApi from '@/api/rundownItems';
import rundownsApi from '@/api/rundowns';

export default {
	name: 'Live',
	components: {

	},
	props: {

	},
	sockets: {
		connect() {
			this.initSocket();
		},
		live(item) {
			this.onStartPlay(item);
		},
		both(item) {
			this.onStartPlay(item);
		},
	},
	data() {
		return {
			rundown: {},
			items: [],
		};
	},
	created() {
		this.initSocket();
		$('body').css('background-color', 'transparent');
		$('html.md-theme-default').css('background-color', 'transparent');

		$(document).find('main').removeClass('main');
		$('html').css('overflow', 'hidden');
		this.setNavbarVisible(false);
		this.setDrawerVisible(false);
		this.fetch();
	},
	destroyed() {

	},
	beforeDestroy() {
		$(document).find('main').addClass('main');
		$('body').css('background-color', '');
		$('html.md-theme-default').css('background-color', '');
		$('html').css('overflow', 'visible');
		this.setNavbarVisible(true);
		this.setDrawerVisible(true);
	},
	mounted() {

	},
	methods: {
		...mapActions({
			setNavbarVisible: 'setNavbarVisible',
			setDrawerVisible: 'setDrawerVisible',
		}),
		initSocket() {
			this.$socket.client.emit('join', this.room);
		},
		removeElement(item) {
			const element = document.getElementById(`${item.type}-${item.id}`);
			if (element) {
				element.remove();
			}
		},
		onStartPlay(item) {
			const itemContent = JSON.parse(item.content);
			if (item.is_play_live) {
				if (item.type === 'media') {
					this.addImageElement(item, itemContent);
				}
			} else {
				// eslint-disable-next-line no-lonely-if
				if (item.type === 'media') {
					this.removeElement(item);
				}
			}
		},
		fetch() {
			const slug = atob(this.$route.params.slug);
			const callback = (response) => {
				const rundown = response.data;
				this.rundown = rundown;
				this.fetchItems();
			};
			const errorCallback = () => {

			};
			rundownsApi.getBySlug(slug, callback, errorCallback);
		},
		fetchItems() {
			const rundownId = this.rundown.id;
			const params = {
				page: 1,
				limit: 1000,
				order_by: 'created_at',
				sort_by: 'desc',
				rundown_id: rundownId,
			};

			const callback = (response) => {
				const items = response.data;
				this.items = items;
				this.items.forEach((item) => {
					this.onStartPlay(item);
				});
			};
			const errorCallback = (e) => {
				const message = getAxiosErrorMessage(e);
				this.$notify({
					group: 'app',
					type: 'error',
					title: 'Rundown Assets',
					text: message,
				});
			};
			rundownItemsApi.getList(params, callback, errorCallback);
		},
		addImageElement(item, content) {
			const img = new Image();
			img.onload = () => {
				document.getElementById('livemain').appendChild(img);
			};
			img.id = `${item.type}-${item.id}`;
			img.scrolling = 'no';
			img.style.zIndex = item.layer_index;
			img.style.position = 'absolute';
			img.src = content.url;
			if (content.opacity) img.style.opacity = content.opacity;
			if (content.width) img.style.width = `${content.width}px`;
			if (content.height) img.style.height = `${content.height}px`;
			if (content.position) img.className = `element-position ${content.position}`;
			if (content.x) img.style.top = `${content.x}px`;
			if (content.y) img.style.left = `${content.y}px`;
		},
	},
	computed: {
		room() {
			const slug = atob(this.$route.params.slug);
			const room = `rundown_${slug}`;
			return room;
		},
	},
};
</script>
